<div class="main-content">
  <div class="container-fluid">
      <div class="row">
          <div class="col-md-12">
              <div class="card">
                  <div class="card-header card-header-danger">
                      <h4 class="card-title">Add assignee User</h4>
                  </div>
                  <div class="card-body">
                        <form [formGroup]="AddAssignerForm">
                      <div class="row">
                        
                              <div class="col-md-6">
                                <mat-form-field class="example-full-width">
                                  <input matInput placeholder="Name" type="text" [(ngModel)]="form.name" formControlName="Name"
                                   >
                                  <mat-error *ngIf="NameFormControl.hasError('required')">
                                       Name is <strong>required</strong>
                                    </mat-error>
                                </mat-form-field>
                              </div>
                              <div class="col-md-6">
                                  <mat-form-field class="example-full-width">
                                    <input matInput placeholder="Email address" type="email" [(ngModel)]="form.email" formControlName="Email"
                                    appLowercaseInput >
                                    <mat-error *ngIf="emailFormControl.hasError('email') && !emailFormControl.hasError('required')">
                                        Please enter a valid email address
                                      </mat-error>
                                      <mat-error *ngIf="emailFormControl.hasError('required')">
                                        Email is <strong>required</strong>
                                      </mat-error>
                                   </mat-form-field>
                              </div>
                              <div class="col-md-6">
                                <mat-form-field class="example-full-width">
                                  <input matInput placeholder="Mobile" type="tel" [(ngModel)]="form.mobile" formControlName="Mobile"
                                   >
                                    <mat-error *ngIf="fc.Mobile.hasError('required')">
                                      Mobile is <strong>required</strong>
                                    </mat-error>
                                 </mat-form-field>
                            </div>
                          </div>
                        
                          <div class="row">
                            <div class="col-md-6">
                                <div class="form-group">
                                  <label>Departments </label>
                                  <ng-select  class="form-control" [items]="department" 
                                  [multiple]="true"
                                  bindLabel="name" 
                                  bindValue="id" 
                                  formControlName="Departemnts" 
                                  [style.border]="fc.Departemnts.touched ? (fc.Departemnts.invalid ? '1px solid #dc3545 !important' : (fc.Departemnts.valid && fc.Departemnts.touched ? '1px solid #28a745' : 'none')) : 'none'"
                                  >
                                </ng-select>
                                </div>
                            </div>
                            <div class="col-md-6">
                              <div class="form-group">
                                <label>Branch </label>
                                <ng-select  class="form-control" [items]="AllBranchs" 
                                [multiple]="true"
                                bindLabel="name" 
                                bindValue="id" 
                                formControlName="Branchs" 
                                [style.border]="fc.Branchs.touched ? (fc.Branchs.invalid ? '1px solid #dc3545 !important' : (fc.Branchs.valid && fc.Branchs.touched ? '1px solid #28a745' : 'none')) : 'none'"
                                >
                              </ng-select>
                              </div>
                          </div>
                        </div>

                       
                          <button mat-raised-button type="submit" *ngIf="!update"  [disabled]="AddAssignerForm.invalid" class="btn primary pull-right"
                           (click)="AddAssigner()" >Add Assigner</button>
                           <button mat-raised-button type="submit" *ngIf="update"  class="btn primary pull-right"
                           (click)="AddAssigner()" >Save</button>
                          <div class="clearfix"></div>
                      </form>
                
                    <br>
                      <mat-form-field class="mt-5">
                       <input matInput (keyup)="applyFilter($event.target.value)" placeholder="Filter">
                     </mat-form-field>
                     
                     
                        
                        <!-- <table mat-table [dataSource]="assigns" class="mat-elevation-z8">
                        
                    
                        
                          <ng-container matColumnDef="name">
                            <th mat-header-cell *matHeaderCellDef> Name </th>
                            <td mat-cell *matCellDef="let element"> {{element.name}} </td>
                          </ng-container>

                          <ng-container matColumnDef="email">
                            <th mat-header-cell *matHeaderCellDef> email </th>
                            <td mat-cell *matCellDef="let element"> {{element.email}} </td>
                          </ng-container>
                          <ng-container matColumnDef="mobile">
                            <th mat-header-cell *matHeaderCellDef> mobile </th>
                            <td mat-cell *matCellDef="let element"> {{element.mobile}} </td>
                          </ng-container>
                          <ng-container matColumnDef="action">
                              <th mat-header-cell *matHeaderCellDef> Action </th>   
                              <td mat-cell *matCellDef="let element"> 
                                <button mat-raised-button *ngIf="currentuser.role == 'admin' ||currentuser.role == 'cluster'|| currentuser.role == 'ceo' "  (click)= "edit(element)" ><i class="material-icons">
                                    edit
                                    </i></button> 
                                <button mat-raised-button *ngIf="currentuser.role == 'admin' ||currentuser.role == 'cluster'|| currentuser.role == 'ceo' "  (click)= "delete(element)" ><i class="material-icons">
                                    delete
                                    </i></button> 
                            
                              </td>
                            </ng-container>
                        
                          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                          <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
                        </table> -->
                        <!-- <table mat-table [dataSource]="assigns" class="mat-elevation-z8 table-responsive">

                          <ng-container matColumnDef="name">
                            <th mat-header-cell *matHeaderCellDef> Name </th>
                            <td mat-cell *matCellDef="let element"> {{element.name}} </td>
                          </ng-container>
                        
                          <ng-container matColumnDef="email">
                            <th mat-header-cell *matHeaderCellDef> Email </th>
                            <td mat-cell *matCellDef="let element"> {{element.email}} </td>
                          </ng-container>
                        
                          <ng-container matColumnDef="mobile">
                            <th mat-header-cell *matHeaderCellDef> Mobile </th>
                            <td mat-cell *matCellDef="let element"> {{element.mobile}} </td>
                          </ng-container>
                        
                          <ng-container matColumnDef="action">
                            <th mat-header-cell *matHeaderCellDef> Action </th>   
                            <td mat-cell *matCellDef="let element"> 
                              <button mat-raised-button *ngIf="currentuser.role == 'admin' ||currentuser.role == 'cluster'|| currentuser.role == 'ceo'" (click)="edit(element)">
                                <i class="material-icons">edit</i>
                              </button> 
                              <button mat-raised-button *ngIf="currentuser.role == 'admin' ||currentuser.role == 'cluster'|| currentuser.role == 'ceo'" (click)="delete(element)">
                                <i class="material-icons">delete</i>
                              </button> 
                            </td>
                          </ng-container>
                        
                          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                          <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
                        
                        </table> -->

                        <div class="table-responsive">
                          <table mat-table [dataSource]="assigns" class="mat-elevation-z8 mt-3 table">
                        
                            <!-- Name Column -->
                            <ng-container matColumnDef="name">
                              <th mat-header-cell *matHeaderCellDef> Name </th>
                              <td mat-cell *matCellDef="let element"> {{element.name}} </td>
                            </ng-container>
                        
                            <!-- Email Column -->
                            <ng-container matColumnDef="email">
                              <th mat-header-cell *matHeaderCellDef> Email </th>
                              <td mat-cell *matCellDef="let element"> {{element.email}} </td>
                            </ng-container>
                        
                            <!-- Mobile Column -->
                            <ng-container matColumnDef="mobile">
                              <th mat-header-cell *matHeaderCellDef> Mobile </th>
                              <td mat-cell *matCellDef="let element"> {{element.mobile}} </td>
                            </ng-container>
                        
                            <!-- Action Column -->
                            <ng-container matColumnDef="action">
                              <th mat-header-cell *matHeaderCellDef> Action </th>
                              <td mat-cell *matCellDef="let element">
                                <button mat-raised-button *ngIf="currentuser.role == 'admin' || currentuser.role == 'cluster' || currentuser.role == 'ceo'" (click)="edit(element)">
                                  <i class="material-icons">edit</i>
                                </button>
                                <button mat-raised-button *ngIf="currentuser.role == 'admin' || currentuser.role == 'cluster' || currentuser.role == 'ceo'" (click)="delete(element)">
                                  <i class="material-icons">delete</i>
                                </button>
                              </td>
                            </ng-container>
                        
                            <!-- Table rows -->
                            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
                        
                          </table>
                        </div>
                        
                        
                  </div>
              </div>
          </div>
    </div>
      </div>

  </div>
